// SW-10381 retires only personal GPT-3.5 fine-tunes. GPT-4/4o fine-tunes
// and the newer sample-based My Voice feature have separate lifecycles.
const RETIRED_BASE = /^(?:ft:)?gpt-3\.5-turbo(?:-[\d-]+)?(?::|$)/;

export function isRetiredLegacyVoiceFineTune(fineTune) {
  const job = fineTune?.openai_fine_tune_job;
  const checkpoints = Array.isArray(job?.checkpoints) ? job.checkpoints : [];
  const models = [job?.model, job?.fine_tuned_model,
    ...checkpoints.map((checkpoint) => checkpoint?.fine_tuned_model_checkpoint)];
  return models.some((model) => typeof model === "string" && RETIRED_BASE.test(model));
}

export function legacyVoiceFineTuneId(selection) {
  // Older generation callers also accepted the bare database ID.
  return typeof selection === "string"
    ? selection.replace(/^CUSTOM_/, "").split("_")[0]
    : undefined;
}

export function isSelectableLegacyVoiceModel(model) {
  return model.status === "succeeded" && !model.retired;
}

export function resolveLegacyVoiceProseMode(selection, models = []) {
  if (typeof selection !== "string" || !selection.startsWith("CUSTOM_")) return selection;
  const id = legacyVoiceFineTuneId(selection);
  // The API can return checkpoint rows without a separate parent row.
  return id && models.some((model) => model.retired && model.id.split("_")[0] === id)
    ? "EXCELLENT"
    : selection;
}
